// extracted by mini-css-extract-plugin
module.exports = {"root":"DefinitionsList_root__thA_3","term":"DefinitionsList_term__Y2qGG","definition":"DefinitionsList_definition__3asgW"};